<template>
  <v-app-bar color="grey-lighten-5" height="90">
    <v-app-bar-nav-icon class="d-md-none" @click="layout.toggleDrawer()" />
    <v-spacer class="d-md-none" />

    <!--
      <img> plano, no <v-img>, a propósito. Vuetify posiciona la imagen interna de
      v-img en absolute con `z-index: -1`, y como .v-img no crea contexto de
      apilamiento, esa imagen termina DETRÁS del fondo de la barra: quedaba
      invisible. v-img aporta lazy-load, placeholder y aspect-ratio, nada de lo
      cual hace falta para un logo estático.

      El tamaño tampoco se copia de V2: allí era `max-width="60px"` sobre un logo
      de 401x99, o sea 60x15 con el texto de 4px, ilegible. 140px respeta la
      proporción y entra de sobra en una barra de 90px.
    -->
    <img
      class="d-none d-md-block ml-4"
      :src="logo"
      alt="Agile"
      width="140"
      style="cursor: pointer; height: auto"
      @click="goTo('/gateway')"
    />
    <v-toolbar-title
      class="py-5 pl-5 text-grey-darken-2"
      style="cursor: pointer"
      @click="goTo('/gateway')"
    >
      Banco de Firma
    </v-toolbar-title>

    <v-spacer />

    <v-menu location="bottom">
      <template #activator="{ props }">
        <v-avatar v-ripple color="indigo" class="mr-2" v-bind="props">
          <span v-if="initial" class="text-white text-h5">{{ initial }}</span>
          <v-icon v-else>mdi-account</v-icon>
        </v-avatar>
      </template>
      <v-list density="compact">
        <v-list-subheader>{{ displayName }}</v-list-subheader>
        <v-list-item v-if="adminEntry" @click="goTo(adminEntry)">
          <v-list-item-title>Ir a Administración</v-list-item-title>
          <template #append>
            <v-icon>mdi-cogs</v-icon>
          </template>
        </v-list-item>
        <v-list-item v-if="systemEntry" @click="goTo(systemEntry)">
          <v-list-item-title>Ir a Sistema</v-list-item-title>
          <template #append>
            <v-icon>mdi-server</v-icon>
          </template>
        </v-list-item>
        <v-list-item @click="goTo('/my/profile')">
          <v-list-item-title>Mi Cuenta</v-list-item-title>
          <template #append>
            <v-icon>mdi-account</v-icon>
          </template>
        </v-list-item>
        <v-list-item @click="auth.logout()">
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
          <template #append>
            <v-icon>mdi-exit-to-app</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";
import logo from "@/assets/img/logo.png";
import { useAuthStore } from "@/stores/auth";
import { useLayoutStore } from "@/stores/layout";
import { ADMIN_SECTIONS, SYSTEM_SECTIONS, firstAccessible } from "@/router/sections";

const router = useRouter();
const auth = useAuthStore();
const layout = useLayoutStore();

/**
 * El componente anterior hacía `currentUser.name[0]` y
 * `currentUser.name.toUpperCase()` sin proteger: `name` es opcional en el DTO, y
 * un perfil sin nombre reventaba la barra completa.
 */
const displayName = computed(() => auth.profile?.name?.toUpperCase() ?? "");
const initial = computed(() => auth.profile?.name?.[0] ?? "");

/**
 * Los enlaces apuntan a la primera sección que el usuario realmente puede ver.
 * Antes "Ir a Administración" iba fijo a /admin/users, así que a un
 * ADMIN_KEYS lo mandaba a un 403.
 */
const adminEntry = computed(() =>
  firstAccessible(ADMIN_SECTIONS, (roles) => auth.canAccess(roles))
);
const systemEntry = computed(() =>
  firstAccessible(SYSTEM_SECTIONS, (roles) => auth.canAccess(roles))
);

function goTo(path: string) {
  router.push({ path });
}
</script>
